/**
 * The function `getUniqueElementsByKey` takes an array of objects and returns a new array with unique
 * elements based on a specified key.
 * @param {T[]} arr - The `arr` parameter is an array of elements of type `T`.
 * @param {string} [key=id] - The `key` parameter in the `getUniqueElementsByKey` function is a string
 * that specifies the property key by which uniqueness is determined when filtering the array `arr`. By
 * default, the function uses the property key 'id' if no key is provided explicitly.
 */
export const getUniqueElementsByKey = <T>(
    arr: T[],
    key: string = 'id',
): T[] => [...new Map(arr.map((item) => [(item as any)[key], item])).values()];

/**
 * Converts an array of strings to an array of numbers.
 * Invalid number conversions (NaN) are skipped by default.
 *
 * @param arr - Array of strings to convert.
 * @param skipInvalid - Whether to skip invalid numbers (default: true).
 * @returns Array of numbers.
 */
export function mapStringsToNumbers(
    arr: string[],
    skipInvalid: boolean = true,
): number[] {
    const result = arr.map((str) => Number(str));

    return skipInvalid ? result.filter((num) => !isNaN(num)) : result;
}
